/**
 * <keystone-hello name="…"> — pipeline smoke-test widget.
 *
 * The first widget. Exists to prove the scaffolding pipeline works:
 *   - TypeScript compiles
 *   - esbuild bundles Lit
 *   - Fastify serves /static/keystone.js
 *   - The page tag renders with reactive properties
 *
 * Will be deleted once the real widgets (Phase 4.4d.iv onwards) ship.
 */

import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("keystone-hello")
export class KeystoneHello extends LitElement {
  static override styles = css`
    :host {
      display: inline-block;
      padding: 0.4rem 0.8rem;
      border-radius: 0.375rem;
      background: #eef1f4;
      color: #1a4d8c;
      font-family: system-ui, sans-serif;
      font-weight: 600;
    }
  `;

  @property({ type: String })
  name = "world";

  override render() {
    return html`👋 hello, ${this.name} — Lit pipeline online.`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "keystone-hello": KeystoneHello;
  }
}
